import { z } from 'zod';
import { TEAM_DUTY_SITUATION_VALUES } from './team-association.registry.js';
import { TeamAssignmentMemberSchema } from './team-assignment.schema.js';
import {
    ExecutionTaskCatalogSchema,
    MAX_OPERATIONAL_MEMBERS,
    MAX_OPERATIONAL_RUN_ASSIGNMENTS,
    MAX_OPERATIONAL_TASKS,
    OperationalCustomFieldsSchema,
    refineExecutionDefinition,
} from './operational-run.schema.js';

export const DutyDefinitionSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    code: z.string().trim().optional().nullable(),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES),
    description: z.string().optional().nullable(),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).default([]),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).default([]),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine(refineExecutionDefinition);

export const CreateDutyDefinitionSchema = z.object({
    name: z.string().min(1),
    code: z.string().trim().optional().nullable(),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES),
    description: z.string().optional().nullable(),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).optional().default([]),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).optional().default([]),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine(refineExecutionDefinition);

export const UpdateDutyDefinitionSchema = z.object({
    name: z.string().min(1).optional(),
    code: z.string().trim().optional().nullable(),
    situationKey: z.enum(TEAM_DUTY_SITUATION_VALUES).optional(),
    description: z.string().optional().nullable(),
    members: z.array(TeamAssignmentMemberSchema).max(MAX_OPERATIONAL_MEMBERS).optional(),
    executionTasks: z.array(ExecutionTaskCatalogSchema).max(MAX_OPERATIONAL_TASKS).optional(),
    customFields: OperationalCustomFieldsSchema.optional(),
}).superRefine((value, ctx) => {
    if (value.members && value.executionTasks) refineExecutionDefinition(value, ctx);
});

export const AddDutyDefinitionsBodySchema = z.object({
    dutyDefinitionIds: z.array(z.string().min(1)).max(MAX_OPERATIONAL_RUN_ASSIGNMENTS).optional().default([]),
});

export const CreateAndLinkDutyDefinitionSchema = CreateDutyDefinitionSchema;
